<template>
  <div class="instruct-wrapper">
    <div class="instuctor-process-options">
      <WidgetToolbar title="Communications" :icon="require('@/assets/admin-icon/menu/communication-active.svg')">
        <div class="options row">
          <widgetDropdownWithIcon @select="onSwitchPage" :value="2"></widgetDropdownWithIcon>
          <div class="h-spacer"></div>
          <widgetButton @click="newAddForm()" class="btn-secondary">
            Create {{ survey_section_tab == 1 ? "Form" : "Survey" }} +
          </widgetButton>
        </div>
      </WidgetToolbar>
    </div>
    <div class="instruct-widget">
      <div class="tab-widget">
        <div class="tab-header">
          <CommunicationsProcessMenus @selected="onSelectedEmailProcess"></CommunicationsProcessMenus>
        </div>
        <div class="tabs-body">
          <!-- Loading preview -->
          <div class="table-loading-widget" v-if="loading_page_data">
            <loading :height="40" :width="40" :active="true" color="#1ba5a4" background-color="#fff"
              :is-full-page="false" />
          </div>

          <QuestionaireTemplatePanel :phase="active_email_process" @onUseTemplate="onUseTemplate"
            @onAddTemplate="showAddTemplateModal" @onUpdateTemplate="showUpdateTemplateModal">
          </QuestionaireTemplatePanel>

          <div class="left-panel">
            <div class="left-panel-header">
              <widgetTabs v-model="survey_section_tab" :tabs="[
                {
                  title: 'Forms',
                  value: 'evaluation',
                },
                {
                  title: 'Surveys',
                  value: 'survey',
                }
              ]" @change="switchQuestionnaireTab"></widgetTabs>
            </div>
            <div class="left-panel-body">
              <div class="left-panel-body-container">
                <div class="questionnare-item" v-for="(item, index) in survey_data" :key="index"
                  @click="selectedQuestionaireItem(item)" :class="{
                    active:
                      selected_item_details &&
                      selected_item_details.id == item.id,
                  }">
                  <div class="questionnare-name">
                    {{ item.title }}
                  </div>
                  <div class="questionnare-candidates">
                    {{ item.created_at | formatDate }}
                  </div>
                </div>
              </div>

            </div>
          </div>

          <div v-if="selected_item_details" class="right-panel">
            <div class="right-panel-header">
              <div class="right-panel-header-left-side">
                <div class="right-panel-header-title">
                  {{ selected_item_details.title }}
                </div>
                <div class="right-panel-header-subtitle">
                  Created by
                  <span v-if="selected_item_details.user">
                    {{ selected_item_details.user.first_name }}
                    {{ selected_item_details.user.last_name }}
                  </span>
                </div>
                <div v-if="questionnere_active_tab != 1" class="right-panel-header-filter row">
                  <widgetSelect :disabled="questionnere_active_tab != 2" v-model="selected_question"
                    :opt="selected_item_details.processed_questions"
                    :placeholder="`All Questions (${selected_item_details.processed_questions.length})`"
                    @change="filterOnSelectedQuestion"></widgetSelect>
                  <div class="h-spacer"></div>
                  <widgetSelect v-if="selected_question != 'none' && question_answers.length > 0
                  " v-model="selected_answer" :opt="question_answers" :placeholder="`Answers`"
                    @change="filterOnSelectedAnswers"></widgetSelect>
                </div>

                <div v-if="questionnere_active_tab == 1" class="right-panel-header-filter row">
                  <widgetButton @click="show_view_questionnaire_modal = true" class="btn-secondary">
                    View
                    {{ survey_section_tab == 1 ? "Form" : "Survey" }} questions
                  </widgetButton>
                </div>
              </div>
              <div class="right-panel-header-right-side">
                <apexchart ref="questionnaire_chart" v-if="questionnere_active_tab == 1" width="200" height="170"
                  type="donut" :options="chartOptions_bar" :series="series_bar"></apexchart>

                <div class="questionnere-menu row">
                  <widgetSearch v-if="questionnere_active_tab != 1" placeholder="Search student here"
                    v-model="search_member_input" @keyup="searchStudent()" icon="right"></widgetSearch>
                  <div class="h-spacer"></div>
                  <dropdown-menu>
                    <ul>
                      <li>
                        <a @click="duplicateSurvey(selected_item_details)">
                          {{
                            survey_section_tab == 1
                              ? "Duplicate Form"
                              : "Duplicate Survey"
                          }}
                        </a>
                      </li>
                      <li>
                        <a @click="postSurveyOnFeed(selected_item_details)">Post On Feed</a>
                      </li>

                      <li>
                        <a @click="sendSurvey(selected_item_details)">
                          {{
                            survey_section_tab == 1
                              ? "Send Form"
                              : "Send Survey"
                          }}
                        </a>
                      </li>
                      <li v-if="!selected_item_details.is_locked">
                        <a @click="updateSurvey(selected_item_details)">
                          {{
                            survey_section_tab == 1
                              ? "Edit Form"
                              : "Edit Survey"
                          }}
                        </a>
                      </li>
                      <li>
                        <app-dialog :title="survey_section_tab == 1
                          ? 'Delete Form'
                          : 'Delete Survey'
                          " :ask="survey_section_tab == 1
                            ? 'Are you sure you want to delete this form?'
                            : 'Are you sure you want to delete this survey?'
                            " yesText="Delete" noText="Cancel" @onComfirm="deleteSurvey(selected_item_details)">
                          <a>
                            {{
                              survey_section_tab == 1
                                ? "Delete Form"
                                : "Delete Survey"
                            }}
                          </a>
                        </app-dialog>
                      </li>
                    </ul>
                  </dropdown-menu>
                </div>
              </div>
            </div>
            <div class="questionnere-data-tabs">
              <widgetTabs :tabs="[
                {
                  title: `All (${questionnaire_tabs.all})`,
                  value: 'all',
                },
                {
                  title: `Completed (${questionnaire_tabs.completed})`,
                  value: 'completed',
                },
                {
                  title: `Not started (${questionnaire_tabs.not_started})`,
                  value: 'not_started',
                },
              ]" v-model="questionnere_active_tab" @change="onQuestionnaireTabChanged"></widgetTabs>

              <div class="tab-right-options">
                <classDropdown class="as-input" school="school" @onSubmit="getSelectedClass">
                  <span class="selected-class" v-if="!selected_class">
                    All Departments
                  </span>
                  <span class="selected-class" v-else>{{
                    selected_class.data.name
                    }}</span>
                </classDropdown>
              </div>
            </div>
            <div v-if="!loading_questionnaire_data" class="right-panel-body">
              <div class="tab-content">
                <table class="table-data">
                  <thead class="table-header">
                    <tr class="stack-title">
                      <th class="stick-title">Name</th>
                      <th class="stick-title" v-if="questionnere_active_tab == 1">
                        Status
                      </th>
                      <th class="stick-title">Time&Date</th>
                      <th class="stick-title" v-if="questionnere_active_tab == 2">
                        Response
                      </th>
                      <th class="stick-title" v-if="questionnere_active_tab == 3">
                        Action
                      </th>
                    </tr>
                  </thead>
                  <tbody class="table-body" v-for="(student, index) in students.students" :key="index">
                    <tr class="row-data">
                      <td>
                        <div class="row-data-name">
                          <widgetProfile v-if="selected_item_details.response_type == 'anonymous'"
                            :title="`Student ${index + 1}`" :size="30" :text_size="12" :file_name="''"
                            :path="$fullUrl('images/profiles/')" :enableRightMargin="true"></widgetProfile>

                          <widgetProfile v-else :title="`${student.first_name} ${student.last_name}`" :size="30"
                            :text_size="12" :file_name="student.profile_picture" :path="$fullUrl('images/profiles/')"
                            :enableRightMargin="true"></widgetProfile>
                        </div>
                      </td>
                      <td v-if="questionnere_active_tab == 1" style="text-transform: capitalize">
                        <widgetBadget :class="{
                          'badge-primary': student.status == 'completed',
                          'badge-default': student.status == 'not started',
                        }" :text="student.status">
                          <img v-if="student.status == 'completed'" class="icon"
                            src="@/assets/icons/confirm_green.svg" />
                          <img v-else class="icon" src="@/assets/icons/dinied-gray.svg" />
                        </widgetBadget>
                      </td>
                      <td>
                        <span v-if="student.answered_at">
                          {{ student.answered_at | formatDateTime }}
                        </span>
                        <span v-else> --- </span>
                      </td>
                      <td v-if="questionnere_active_tab == 2">
                        <widgetButton v-if="(questionnere_active_tab == 2 &&
                          !selected_question) ||
                          (questionnere_active_tab == 2 &&
                            selected_question &&
                            selected_question == 'none')
                        " :loading="false" class="btn-transparent-secondary fit-content" @click="
                          viewStudentSurvey(student, selected_item_details)
                          ">
                          View all answers
                        </widgetButton>
                        <viewStudentAnswers v-if="questionnere_active_tab == 2 &&
                          selected_question &&
                          selected_question != 'none'
                        " :selectedQuestion="selected_question_obj" :selectedAnswer="selected_answer"
                          :allAnswer="student.answers"></viewStudentAnswers>
                      </td>
                      <td v-if="questionnere_active_tab == 3">
                        <dropdown-menu v-if="questionnere_active_tab == 3">
                          <ul>
                            <li>
                              <a @click="
                                remindStudentForSurvey(
                                  student,
                                  selected_item_details
                                )
                                ">Send Reminder</a>
                            </li>
                          </ul>
                        </dropdown-menu>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div v-if="loading_questionnaire_data" class="right-panel-body">
              <div class="qustionnere-loading-widget">
                <loading :height="20" :width="20" :active="true" color="#1ba5a4" background-color="#fff"
                  :is-full-page="false" />
              </div>
            </div>
          </div>

          <!-- When no item selected -->
          <div class="right-panel" v-if="!selected_item_details">
            <widgetNotFoundWidget title="No Questionnaire selected" content="Select questionnaire to view its details"
              align="center">
              <img class="widget-img" src="@/assets/icons/member-notfound.svg" />
            </widgetNotFoundWidget>
          </div>
        </div>
      </div>
    </div>

    <!-- Create Questionnaire Modal -->
    <createQuestionnaireModal v-if="show_form_modal" :type="selected_tab" :phase="active_email_process"
      :template="questionaire_template_tmp" :value="selected_item_details" @close="show_form_modal = false"
      @saved="onQuestionaireSaved">
    </createQuestionnaireModal>

    <!-- Show questionnaire report modal -->
    <questionnaireReportModal v-if="show_report_modal" :value="selected_item_details"
      :type="survey_section_tab == 1 ? 'evaluation' : 'survey'" :modal="report_modal_type"
      @close="show_report_modal = false">
    </questionnaireReportModal>

    <!-- Send survey modal -->
    <sendSurveyModal v-if="show_send_survey_modal" :value="selected_item_details" :type="selected_tab"
      @close="show_send_survey_modal = false">
    </sendSurveyModal>

    <!-- View questionnaire modal -->
    <viewQuestionnaire v-if="show_view_questionnaire_modal" :questionnaire="selected_item_details" :type="selected_tab"
      @close="show_view_questionnaire_modal = false">
    </viewQuestionnaire>

    <!-- View student questionnaire answer modal -->
    <viewStudentQuestionnaireAnswer v-if="show_view_student_questionnaire_answer_modal"
      :result="selected_student_questionnaire_result" :type="selected_tab" :student="selected_student"
      :questionnaire="selected_item_details" @close="show_view_student_questionnaire_answer_modal = false">
    </viewStudentQuestionnaireAnswer>

    <!-- add template modal -->
    <newTemplateModal v-if="show_new_template_modal" :saveAs="saveAsTemplateIsActive" :phase="active_email_process"
      :value="questionaire_template_tmp" @saved="onTemplateSaved" @close="show_new_template_modal = false">
    </newTemplateModal>
  </div>
</template>

<script>
import { eventBus } from "@/main";
import sendSurveyModal from "./components/sendSurveyModal.vue";
import createQuestionnaireModal from "./components/createQuestionnaireModal.vue";
import questionnaireReportModal from "./components/questionnaireReportModal.vue";
import viewQuestionnaire from "./components/viewQuestionnaire.vue";
import viewStudentQuestionnaireAnswer from "./components/viewStudentQuestionnaireAnswer.vue";
import viewStudentAnswers from "./components/viewStudentAnswers.vue";
import CommunicationsProcessMenus from "./components/CommunicationsProcessMenus.vue";
import QuestionaireTemplatePanel from "./panels/QuestionaireTemplatePanel.vue";
import newTemplateModal from "./components/newTemplateModal.vue"
export default {
  name: "",
  components: {
    sendSurveyModal,
    createQuestionnaireModal,
    questionnaireReportModal,
    viewQuestionnaire,
    viewStudentQuestionnaireAnswer,
    viewStudentAnswers,
    CommunicationsProcessMenus,
    QuestionaireTemplatePanel,
    newTemplateModal
  },
  props: {},
  data: () => {
    return {
      show_send_survey_modal: false,
      show_report_modal: false,
      show_form_modal: false,
      survey_data: [],
      loading_page_data: true,
      selected_item_details: null,
      survey_section_tab: 1,
      selected_tab: "evaluation",
      report_modal_type: "report",
      series_bar: [0, 0],
      chartOptions_bar: {
        chart: {
          height: 350,
          type: "bar",
        },
        plotOptions: {
          bar: {
            horizontal: true,
          },
        },
        colors: ["#1BA5A4", "#FEC42E"],
        dataLabels: {
          formatter: function (val, opt) {
            return parseInt(val) + "%";
          },
        },
        legend: {
          show: true,
          showForSingleSeries: true,
          customLegendItems: ["Completed", "Not started"],
          position: "bottom",
          markers: {
            fillColors: ["#1BA5A4", "#FEC42E"],
          },
        },
        // Hide label on hover
        tooltip: {
          enabled: true,
          y: {
            formatter: function (val) {
              return val + "%";
            },
            title: {
              formatter: (seriesName) => {
                if (seriesName == "series-1") {
                  return "Completed";
                } else if (seriesName == "series-2") {
                  return "Not started";
                } else {
                  return "";
                }
              },
            },
          },
        },
      },
      filter_survey_form: {
        questionnaire_id: null,
        question: "",
        answer: "",
        student_status: "all",
        id: null,
        id_type: "",
        query: "",
      },
      selected_class: null,
      loading_questionnaire_data: false,
      questionnere_active_tab: 1,
      selected_question: "none",
      selected_answer: "none",
      students: [],
      question_answers: [],
      search_member_input: "",
      show_view_questionnaire_modal: false,
      show_view_student_questionnaire_answer_modal: false,
      selected_student: null,
      selected_student_questionnaire_result: null,
      questionnaire_tabs: {
        all: 0,
        completed: 0,
        not_started: 0,
      },
      selected_question_obj: null,
      active_email_process: "prior-lia",
      questionaire_template_tmp: null,
      show_new_template_modal: false,
      saveAsTemplateIsActive: false
    };
  },
  mounted() {
    let vm = this;
    vm.getAllSurveyData();
  },
  computed: {},
  watch: {},
  methods: {
    // Questionnaire Template
    onTemplateSaved() {
      let vm = this;
      vm.show_new_template_modal = false;
      eventBus.$emit("QuestinaireRefleshTemplate");
    },
    onUseTemplate(item) {
      let vm = this;
      vm.selected_item_details = null;
      vm.questionaire_template_tmp = item;
      vm.show_form_modal = true;
    },
    showAddTemplateModal() {
      let vm = this;
      vm.questionaire_template_tmp = null;
      vm.selected_item_details = null;
      vm.show_new_template_modal = true;
    },
    showUpdateTemplateModal(item) {
      let vm = this;
      vm.questionaire_template_tmp = item;
      vm.selected_item_details = null;
      vm.show_new_template_modal = true;
    },
    // Questionnaire
    onSelectedEmailProcess(name) {
      let vm = this;
      vm.active_email_process = name;
      setTimeout(() => {
        eventBus.$emit("QuestinaireRefleshTemplate");
      }, 100);
      vm.switchQuestionnaireTab("evaluation");
    },
    onSwitchPage(item) {
      let vm = this;
      vm.$emit("switchPage", item);
    },
    duplicateSurvey(item) {
      let vm = this;
      vm.$store
        .dispatch("PROCESSMESSAGE_SURVEY_DUPLICATE", { id: item.id })
        .then((responce) => {
          vm.selected_item_details = null;
          vm.getAllSurveyData(vm.selected_tab);
          vm.$notify({
            group: "status",
            title: "Success",
            text:
              vm.survey_section_tab == 1
                ? "Form is duplicated successfully"
                : "Survey is duplicated successfully",
            type: "success",
            duration: 3000,
          });
        })
        .catch((error) => {
          vm.$notify({
            group: "status",
            title: "Warning",
            text: "Something went wrong while duplicating",
            type: "warn",
            duration: 3000,
          });
        });
    },
    remindStudentForSurvey(student, item) {
      let vm = this;
      vm.$store
        .dispatch("PROCESSMESSAGE_SURVEY_REMIND", {
          id: item.id,
          student_id: student.id,
          link: `https://meritios.com/questionnaire/${item.id}`,
        })
        .then((responce) => {
          vm.$notify({
            group: "status",
            title: "Success",
            text: "Reminder sent successfully",
            type: "success",
            duration: 3000,
          });
        })
        .catch((error) => {
          vm.$notify({
            group: "status",
            title: "Warning",
            text: "Something went wrong while sending reminder",
            type: "warn",
            duration: 3000,
          });
        });
    },
    postSurveyOnFeed(item) {
      let vm = this;
      eventBus.$emit("openDialogMessage", {
        title: "Important Message",
        message: `This questionnaire cannot be changed once it has been submitted. Please double-check before sending or post.`,
        action_label: "Continue",
        action_close_label: "Close",
        callback: () => {
          vm.$store
            .dispatch("COMMUNICATION_LOCK_QUESTIONAIRE", {
              id: item.id,
            })
            .then((responce) => {
              window.parent.postMessage(
                {
                  message: "routeNow",
                  value: {
                    name: "feeds",
                    query: { path: `questionnaire/${item.id}`, new: true },
                  },
                },
                "*"
              );
            })
            .catch((error) => {
              vm.$notify({
                group: "status",
                title: "Success",
                text: "Something went wrong, try again",
                type: "warn",
                duration: 3000,
              });
            });
        },
      });
    },
    onQuestionaireSaved(data) {
      let vm = this;
      vm.show_form_modal = false;
      if (!vm.selected_item_details && !vm.questionaire_template_tmp) {
        eventBus.$emit("openDialogMessage", {
          title: "New template",
          message: "Would you consider saving this questionnaire as a template for future use? This way, you can easily reference and reuse the content without having to recreate it each time.",
          action_label: "Yes, save as template",
          action_path: null,
          action_close_label: "Don’t save",
          callback: () => {
            vm.questionaire_template_tmp = data;
            vm.show_new_template_modal = true;
          },
        });
      }
      vm.selected_item_details = null;
      vm.getAllSurveyData(vm.selected_tab);
    },
    sendSurvey(item) {
      let vm = this;
      vm.selected_item_details = item;
      vm.show_send_survey_modal = true;
    },
    viewStudentSurvey(student, item) {
      let vm = this;
      console.log(item);
      vm.$store
        .dispatch("COMMUNICATION_VIEW_QUESTIONAIRE_RESULT", {
          id: item.id,
          student_id: student.id,
        })
        .then((responce) => {
          vm.selected_student = student;
          if (responce.data.length > 0) {
            vm.selected_student_questionnaire_result =
              responce.data[0].answer.map((item) => item);
            vm.show_view_student_questionnaire_answer_modal = true;
          }
        })
        .catch((error) => {
          console.error({ error });
          vm.$notify({
            group: "status",
            title: "Warning",
            text: "Something went wrong while viewing survey result",
            type: "warn",
            duration: 3000,
          });
        });
    },
    selectedQuestionaireItem(item) {
      let vm = this;
      // check if item.question is string
      if (typeof item.question == "string") {
        vm.selected_item_details = item;
        eventBus.$set(
          vm.selected_item_details,
          "questions",
          JSON.parse(item.question)
        );
        eventBus.$set(
          vm.selected_item_details,
          "processed_questions",
          vm.selected_item_details.questions.map((item) => {
            return { label: item.ask, value: item.ask };
          })
        );
        vm.filter_survey_form.questionnaire_id = item.id;
        vm.loading_questionnaire_data = true;
        if (vm.filter_survey_form.student_status == "all") {
          vm.$store
            .dispatch("COMMUNICATION_GET_QUESTIONAIRE", vm.filter_survey_form)
            .then((responce) => {
              vm.loading_questionnaire_data = false;
              vm.students = responce.data;
              let all_student = vm.students.completed + vm.students.not_started;
              vm.questionnaire_tabs.all = all_student;
              vm.questionnaire_tabs.completed = vm.students.completed;
              vm.questionnaire_tabs.not_started = vm.students.not_started;
              let completed_percentage = parseInt(
                Math.round((vm.students.completed / all_student) * 100)
              );
              let not_started_percentage = parseInt(
                Math.round((vm.students.not_started / all_student) * 100)
              );
              vm.$refs.questionnaire_chart.updateSeries(
                [completed_percentage, not_started_percentage],
                false,
                true
              );
            })
            .catch((error) => {
              vm.loading_questionnaire_data = false;
            });
        } else if (vm.filter_survey_form.student_status == "completed") {
          vm.$store
            .dispatch(
              "COMMUNICATION_COMPLETED_QUESTIONAIRE",
              vm.filter_survey_form
            )
            .then((responce) => {
              vm.loading_questionnaire_data = false;
              vm.students.students = responce.data;
              vm.questionnaire_tabs.completed = responce.data.length;
            })
            .catch((error) => {
              vm.loading_questionnaire_data = false;
            });
        } else if (vm.filter_survey_form.student_status == "not_started") {
          vm.$store
            .dispatch(
              "COMMUNICATION_NOT_STARTED_QUESTIONAIRE",
              vm.filter_survey_form
            )
            .then((responce) => {
              vm.loading_questionnaire_data = false;
              vm.students.students = responce.data;
              vm.questionnaire_tabs.not_started = responce.data.length;
            })
            .catch((error) => {
              vm.loading_questionnaire_data = false;
            });
        }
      } else {
        vm.$notify({
          group: "status",
          title: "Success",
          text: "Something went wrong, Invalid questionnare",
          type: "warn",
          duration: 3000,
        });
      }
    },
    onQuestionnaireTabChanged(tab) {
      let vm = this;
      vm.filter_survey_form.student_status = tab.value;
      vm.selectedQuestionaireItem(vm.selected_item_details);
    },
    filterOnSelectedQuestion({ target }) {
      let vm = this;
      let question = vm.selected_item_details.questions.find(
        (item) => item.ask == target.value
      );
      if (question) {
        vm.selected_question_obj = question;
      }
      if (
        (question && question.question_type == "multiple_choice") ||
        (question && question.question_type == "checkboxes") ||
        (question && question.question_type == "dropdown")
      ) {
        vm.question_answers = question.choice_options.map((item) => {
          return { label: item.name, value: item.name };
        });
      } else {
        vm.question_answers = [];
      }
      vm.filter_survey_form.question = target.value;
      if (target.value == "none") {
        vm.selected_answer = "none";
        vm.filter_survey_form.question = "";
      }
      vm.selectedQuestionaireItem(vm.selected_item_details);
    },
    filterOnSelectedAnswers({ target }) {
      let vm = this;
      vm.filter_survey_form.answer = target.value;
      if (target.value == "none") {
        vm.filter_survey_form.answer = "";
      }
      vm.selectedQuestionaireItem(vm.selected_item_details);
    },
    searchStudent() {
      let vm = this;
      vm.filter_survey_form.query = vm.search_member_input;
      vm.selectedQuestionaireItem(vm.selected_item_details);
    },
    getSelectedClass(item) {
      let vm = this;
      if (item.type == "school") {
        vm.selected_class = null;
        vm.filter_survey_form.id = null;
        vm.filter_survey_form.id_type = item.type;
        vm.selectedQuestionaireItem(vm.selected_item_details);
      } else {
        vm.selected_class = item;
        vm.filter_survey_form.id = item.data.id;
        vm.filter_survey_form.id_type = item.type;
        vm.selectedQuestionaireItem(vm.selected_item_details);
      }
    },
    deleteSurvey(item) {
      let vm = this;
      vm.$store
        .dispatch("PROCESSMESSAGE_SURVEY_DELETE", { id: item.id })
        .then((responce) => {
          vm.selected_item_details = null;
          vm.getAllSurveyData(vm.selected_tab);
          vm.$notify({
            group: "status",
            title: "Success",
            text:
              vm.survey_section_tab == 1
                ? "Form is now deleted"
                : "Survey is now deleted",
            type: "success",
            duration: 3000,
          });
        })
        .catch((error) => {
          item.loading = false;
          vm.$notify({
            group: "status",
            title: "Warning",
            text: "Something wrong while deleting survey",
            type: "warn",
            duration: 3000,
          });
        });
    },
    switchQuestionnaireTab(tab) {
      let vm = this;
      vm.questionnere_active_tab = 1;
      vm.filter_survey_form.questionnaire_id = null;
      vm.filter_survey_form.question = "";
      vm.filter_survey_form.answer = "";
      vm.filter_survey_form.id = null;
      vm.filter_survey_form.id_type = "";
      vm.filter_survey_form.query = "";
      vm.selected_question = "none";
      vm.selected_answer = "none";
      vm.selected_class = null;
      vm.selected_item_details = null;
      vm.selected_tab = tab.value;
      vm.getAllSurveyData(tab.value);
    },
    getAllSurveyData(type = "evaluation") {
      let vm = this;
      vm.loading_page_data = true;
      vm.$store
        .dispatch("PROCESSMESSAGE_SURVEY_GET_ALL", {
          type: type,
          phase: vm.active_email_process
        })
        .then((responce) => {
          vm.loading_page_data = false;
          vm.survey_data = responce.data.map((item) => {
            eventBus.$set(item, "editing", false);
            eventBus.$set(item, "loading", false);
            return item;
          });
        })
        .catch((error) => {
          vm.loading_page_data = false;
        });
    },
    viewStudentsResult(item) {
      let vm = this;
      vm.report_modal_type = "anonymous";
      vm.selected_item_details = item;
      vm.show_report_modal = true;
    },
    viewReport(item) {
      let vm = this;
      vm.selected_item_details = item;
      vm.report_modal_type = "report";
      vm.show_report_modal = true;
    },
    viewSurveyResult(item) {
      let vm = this;
      vm.report_modal_type = "result";
      vm.selected_item_details = item;
      vm.show_report_modal = true;
    },
    updateSurvey(item) {
      let vm = this;
      vm.selected_item_details = item;
      vm.show_form_modal = true;
    },
    newAddForm() {
      let vm = this;
      vm.selected_item_details = null;
      vm.questionaire_template_tmp = null;
      vm.show_form_modal = true;
    },
  },
};
</script>
<style lang="scss" scoped>
$assets: "~@/assets";

.instruct-wrapper {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;

  .instuctor-process-options {
    position: absolute;
    top: 5px;
    right: 5px;
    left: 5px;
  }

  .instruct-widget {
    height: 100%;
    display: flex;
    flex-direction: column;

    .tab-widget {
      height: 100%;
      display: flex;
      flex-direction: column;

      .tab-header {
        display: flex;
        width: 100%;
        height: 36px;
      }

      .tabs-body {
        height: calc(100% - 40px);
        width: 100%;
        display: flex;
        justify-content: space-between;
        position: relative;

        &.noTab {
          height: 100%;
        }

        .table-loading-widget {
          position: absolute;
          left: 0px;
          top: 0px;
          bottom: 0px;
          right: 0px;
          background: #fff;
          z-index: 9999;
          border-radius: 10px;
        }

        .left-panel {
          width: 300px;
          height: 100%;
          border-radius: 5px;
          overflow: hidden;
          margin-right: 5px;

          .left-panel-header {
            height: 50px;
            display: flex;
            align-items: center;
            padding: 0px 5px;
            background-color: #fff;
          }

          .left-panel-body {
            height: calc(100% - 50px);
            overflow-y: auto;

            .left-panel-body-container {
              background-color: #fff;

              .questionnare-item {
                display: flex;
                align-items: center;
                height: 40px;
                padding: 0px 15px;
                cursor: pointer;
                border: 1px solid transparent;
                box-shadow: 0px 2px 6px transparent;

                &:hover {
                  background: #fbfbfb;
                  border: 1px solid #1ba5a4;
                  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.25);
                  border-radius: 5px;
                }

                &.active {
                  background: #fbfbfb;
                  border: 1px solid #1ba5a4;
                  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.25);
                  border-radius: 5px;
                }

                .questionnare-name {
                  width: 70%;
                  overflow: hidden;
                  text-decoration: none;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                }

                .questionnare-candidates {
                  width: 30%;
                  display: flex;
                  align-items: center;
                  font-style: normal;
                  font-weight: 600;
                  font-size: 10px;
                  color: #707070;
                }
              }
            }
          }
        }

        .right-panel {
          width: calc(100% - 648px);
          height: 100%;
          background-color: #fff;
          border-radius: 5px;

          .right-panel-header {
            display: flex;
            padding: 0px 15px;
            font-weight: 600;
            font-size: 16px;
            color: #707070;
            height: 170px;

            .right-panel-header-left-side {
              width: 60%;
              padding: 15px 0px;

              .right-panel-header-title {
                font-size: 20px;
                font-weight: 600;
                color: #707070;
              }

              .right-panel-header-subtitle {
                font-size: 14px;
                font-weight: 400;
                color: #707070;
                margin: 10px 0px;
              }

              .right-panel-header-filter {
                padding-top: 15px;
              }
            }

            .right-panel-header-right-side {
              width: 40%;
              padding: 15px 0px;
              position: relative;

              .questionnere-menu {
                position: absolute;
                top: 15px;
                right: 0px;
              }
            }
          }

          .questionnere-data-tabs {
            border-bottom: 1px solid #ddd;
            height: 45px;
            display: flex;
            align-items: flex-end;

            .tab-right-options {
              margin-bottom: 5px;
              padding-right: 15px;
            }
          }

          .right-panel-body {
            height: calc(100% - 215px);
            padding-bottom: 50px;
            position: relative;
            display: flex;
            flex-direction: column;
            padding: 5px;

            .qustionnere-loading-widget {
              position: absolute;
              left: 0px;
              top: 0px;
              bottom: 0px;
              right: 0px;
              background: #fff;
              z-index: 9999;
              border-radius: 10px;
            }

            .tab-content {
              overflow-y: auto;
            }
          }
        }
      }
    }
  }
}
</style>

<style lang="scss">
.tab-content-details-body {
  p {
    margin: 0px;
  }
}
</style>
